
import { MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from '../environments/environment';

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msal.clientId,
      authority: environment.msal.authority,
      redirectUri: environment.msal.redirectUri
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(`${environment.msal.protectedResourceURL}`, [environment.msal.scope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

//This function not being used now, but we could use Guard instead of Interceptor.
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [
        environment.msal.scope,
        'openid',
        'profile',
        'offline_access' // optional, if you want refresh tokens
      ]
    }
  };
}

export function initializeMsal(msalInstance: PublicClientApplication): () => Promise<void> {
  return () => msalInstance.initialize();
}
